import React, { createContext, useContext } from 'react'

type BrightspotRoutingContext = {
  basePath: string
}

type BrightspotRoutingProviderProps = {
  basePath: string
  children: React.ReactNode
}

export const BrightspotRoutingContext = createContext({} as BrightspotRoutingContext)

export default function BrightspotRoutingProvider({ basePath, children }: BrightspotRoutingProviderProps): JSX.Element {
  return <BrightspotRoutingContext.Provider value={{ basePath }}>{children}</BrightspotRoutingContext.Provider>
}

export function useBrightspotRouting(): BrightspotRoutingContext {
  return useContext(BrightspotRoutingContext)
}
